The date and time when the position was last updated in the partner's system.
